function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20",
  "data-name": "Rectangle 20",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-2",
  "data-name": "Dashboard",
  transform: "translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M44,173h6a1,1,0,0,0,1-1v-8a1,1,0,0,0-1-1H44a1,1,0,0,0-1,1v8A1,1,0,0,0,44,173Zm0,8h6a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1H44a1,1,0,0,0-1,1v4A1,1,0,0,0,44,181Zm10,0h6a1,1,0,0,0,1-1v-8a1,1,0,0,0-1-1H54a1,1,0,0,0-1,1v8A1,1,0,0,0,54,181Zm-1-17v4a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1H54A1,1,0,0,0,53,164Z",
  transform: "translate(-43 -163)",
  fill: "#fff"
}));

function SvgDashboardFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFocused);
export default __webpack_public_path__ + "static/media/dashboard_focused.540e330d.svg";
export { ForwardRef as ReactComponent };